import TextareaWithCharacterCount from './TextareaWithCharacterCount';

export default TextareaWithCharacterCount;



// WEBPACK FOOTER //
// ./src/components/TextareaWithCharacterCount/index.tsx